<template>
  <v-dialog
    :model-value="entry !== null"
    width="920px"
    max-width="95%"
    class="blog-dialog"
    @update:model-value="$emit('close')"
  >
    <v-card v-if="entry">
      <v-card-subtitle class="mt-4 mb-n4 px-6">
        <template v-if="entry.date">
          {{ readableDate(entry.date) }}
        </template>
      </v-card-subtitle>

      <v-card-title class="d-flex align-center px-6">
        {{ entry.title }}

        <v-spacer />

        <v-btn
          icon="$close"
          flat
          @click="$emit('close')"
        />
      </v-card-title>

      <div v-if="entry.tags && entry.tags.length > 0" class="mx-6 mb-3">
        <v-chip
          v-for="tag in entry.tags"
          :key="`${entry.id}_${tag.id}`"
          :color="tag.color"
          rounded="xl"
          variant="elevated"
          elevation="0"
          size="small"
          class="mr-2"
        >
          {{ tag.label }}
        </v-chip>
      </div>

      <v-card-text>
        <cms-block-renderer
          v-if="Array.isArray(entry.blocks)"
          :blocks="entry.blocks"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn @click="$emit('close')">
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'blog-dialog',

  props: {
    entry: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'close'
  ],
}
</script>

<style lang="scss">
  .blog-dialog {
    .v-container {
      max-width: none;
      padding: 0;
      margin: 0;
    }

    .mb-15 {
      margin-bottom: 30px !important;
    }
  }
</style>
